(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_slide"] && !Shopify.designMode) return;
  try {
    const ohanaSlideVideoCleanups = new WeakMap();
  const initOhanaSlideVideos = (root) => {
    root.querySelectorAll('template[data-ohana-slide-video]').forEach((template) => {
      if (ohanaSlideVideoCleanups.has(template)) return;
      const original = template.content.querySelector('video');
      if (!original) return;
      const media = window.matchMedia(template.dataset.ohanaSlideVideo);
      const container = template.closest('.slide__image-container');
      const poster = container?.querySelector('.slide__responsive-poster-image') ||
        container?.querySelector(original.classList.contains('slide__video--mobile')
          ? '.slide__video-poster--mobile' : '.slide__video-poster--desktop');
      let video;
      const clearPosterListeners = () => {
        poster?.removeEventListener('load', startVideo);
        poster?.removeEventListener('error', startVideo);
      };
      const startVideo = () => {
        clearPosterListeners();
        if (!media.matches || video || !template.isConnected) return;
        video = original.cloneNode(true);
        video.defaultMuted = true;
        video.muted = true;
        video.playsInline = true;
        if (poster?.naturalWidth) video.poster = poster.currentSrc || poster.src;
        template.after(video);
        video.play()?.catch(() => {});
      };
      const removeVideo = () => {
        if (!video) return;
        video.pause();
        video.removeAttribute('src');
        video.querySelectorAll('source').forEach((source) => source.removeAttribute('src'));
        video.load();
        video.remove();
        video = undefined;
      };
      const update = () => {
        clearPosterListeners();
        if (!media.matches) {
          removeVideo();
        } else if (!video) {
          if (poster && !poster.complete) {
            poster.addEventListener('load', startVideo, { once: true });
            poster.addEventListener('error', startVideo, { once: true });
          } else {
            startVideo();
          }
        }
      };
      media.addEventListener('change', update);
      ohanaSlideVideoCleanups.set(template, () => {
        media.removeEventListener('change', update);
        clearPosterListeners();
        removeVideo();
        ohanaSlideVideoCleanups.delete(template);
      });
      update();
    });
  };
  initOhanaSlideVideos(document);
  document.addEventListener('shopify:section:load', (event) => initOhanaSlideVideos(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('template[data-ohana-slide-video]').forEach((template) => {
      ohanaSlideVideoCleanups.get(template)?.();
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ohana-size-guide')) {
    customElements.define('ohana-size-guide', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.dialog = this.querySelector('dialog');
        this.trigger = this.querySelector('[data-size-guide-trigger]');
        if (!this.dialog || !this.trigger) return;
        this.initialized = true;
        this.viewport = this.querySelector('.ohana-size-guide__viewport');
        this.trigger.addEventListener('click', (event) => {
          event.preventDefault();
          this.dialog.showModal();
          this.setZoom(1);
          this.viewport.scrollTo(0, 0);
        });
        this.querySelector('[data-size-guide-close]').addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const bounds = this.dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
        });
        this.dialog.addEventListener('close', () => this.trigger.focus({ preventScroll: true }));
        this.querySelectorAll('[data-size-guide-zoom]').forEach((button) => {
          button.addEventListener('click', () => this.setZoom(Number(button.dataset.sizeGuideZoom)));
        });
      }
      setZoom(zoom) {
        const previous = this.zoom || 1;
        const x = (this.viewport.scrollLeft + this.viewport.clientWidth / 2) / previous;
        const y = (this.viewport.scrollTop + this.viewport.clientHeight / 2) / previous;
        this.zoom = zoom;
        this.dialog.style.setProperty('--size-guide-zoom', zoom);
        this.querySelectorAll('[data-size-guide-zoom]').forEach((button) => button.setAttribute('aria-pressed', String(Number(button.dataset.sizeGuideZoom) === zoom)));
        this.viewport.scrollTo(Math.max(0, x * zoom - this.viewport.clientWidth / 2), Math.max(0, y * zoom - this.viewport.clientHeight / 2));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
